// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"122":"37a554a0","202":"37a554a0","292":"3e9040e5","560":"efe636a7","610":"a4cf0174","821":"5468807f","873":"37a554a0"}[chunkId] + ".chunk.css";
};